import { gql } from "@apollo/client"

export const DASHBOARD_PGM_GRADUATE_QUERY = gql`
  query DashboardPgmGraduate {
    currentPerson {
      id
      pgmGraduate
    }
  }
`

export const MEMBER_APPLICATION_ELIGIBILITY_QUERY = gql`
  query MemberApplicationEligibility {
    memberApplicationEligibility {
      eligible
      blockingReasons
      playingAbilityTest {
        complete
        expired
      }
      backgroundCheck {
        complete
      }
      age {
        complete
      }
      acceptableProgress {
        complete
        expired
      }
      pgmLevels {
        complete
      }
      experienceCredits {
        total
        threshold
        complete
        educationCredits
        employmentCredits
      }
      goodStanding {
        complete
      }
      activelyEmployed {
        complete
      }
    }
  }
`
